<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.registry-attr.caption', { num: 1 }) }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.registry-attr.caption', { num: 2 }) }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemRegistryAttrInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
